import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submitter']

  submitterTargetConnected = (element) => {
    element.addEventListener('click', () => {
      this.element.submit()
    })
  }
}
